// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChatSettings__icon-c8e556 {
  margin-inline-start: 14px;
}

.ChatSettings__opened-c8fa48 {
  background-color: var(--base-30);
}

.ChatSettings__popover-bf92d4 {
  min-width: 190px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatHeader/DefaultHeader/DefaultHeaderActions/ChatSettings/ChatSettings.styles.m.css"],"names":[],"mappings":"AAAA;EACE,yBAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,gBAAA;AACF","sourcesContent":[".icon {\n  margin-inline-start: 14px;\n}\n\n.opened {\n  background-color: var(--base-30);\n}\n\n.popover {\n  min-width: 190px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `ChatSettings__icon-c8e556`,
	"opened": `ChatSettings__opened-c8fa48`,
	"popover": `ChatSettings__popover-bf92d4`
};
module.exports = ___CSS_LOADER_EXPORT___;
